// Gemeinsame Logik der Planung (Termin/Aufgabe): Dauer, „Nächste freie Zeit“, „Weitere“, Mitarbeiter-Filter.
// Genutzt von der Kopfleiste PlanungsLeiste im Kalender (die einzige Planungsansicht).
import { useRef, useState } from "react";
import { toast } from "sonner";
import { useArbeitszeit } from "./arbeitszeit";
import { monteureVon, naechsteFreieZeit, schreibeZeit, wochenStart } from "./kalenderLogik";

export const DAUERN = [[60, "1 Std."], [120, "2 Std."], [240, "4 Std."], [480, "Ganzer Tag"]];
const TAGE = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
export const zeitText = (v) => {
  const z = (n) => String(n).padStart(2, "0");
  const d = v.start;
  return `${TAGE[d.getDay()]}, ${z(d.getDate())}.${z(d.getMonth() + 1)}., ${z(d.getHours())}:${z(d.getMinutes())}–${z(v.ende.getHours())}:${z(v.ende.getMinutes())} Uhr`;
};

export const usePlanung = ({ modus = "termin", wahl = [], onWahl, termine = [], abwesenheiten = [], startDatum = null }) => {
  const istAufgabe = modus === "aufgabe";
  const arbeitszeit = useArbeitszeit();
  const [dauer, setDauer] = useState(60);
  const [vorschlag, setVorschlag] = useState(null);
  const [springe, setSpringe] = useState(null);
  const angezeigt = useRef(startDatum || new Date());
  const zaehler = useRef(0);

  const aendereWahl = (liste) => { setVorschlag(null); onWahl?.(liste); };
  const sichtbareTermine = wahl.length ? termine.filter((t) => monteureVon(t).some((m) => wahl.includes(m))) : termine;

  const suche = (ab) => {
    if (!wahl.length) { toast.error("Bitte zuerst oben einen Mitarbeiter wählen."); return; }
    const r = naechsteFreieZeit({ ab, dauerMin: istAufgabe ? 60 : dauer, monteure: wahl, termine, abwesenheiten, arbeitszeit });
    if (!r) { toast.error("In den nächsten 90 Tagen ist keine gemeinsame freie Zeit zu finden."); return; }
    setVorschlag(r);
    zaehler.current += 1;
    setSpringe({ datum: r.start, n: zaehler.current });
  };
  const ersteSuche = () => {
    const jetzt = new Date();
    const wochenAnfang = wochenStart(angezeigt.current);
    suche(wochenAnfang.getTime() > jetzt.getTime() ? wochenAnfang : jetzt);
  };
  const weitere = () => { if (vorschlag) suche(vorschlag.ende); };
  const vorschlagWerte = () => (vorschlag ? { start: schreibeZeit(vorschlag.start), ende: schreibeZeit(vorschlag.ende), monteur: "" } : null);
  const setzeDauer = (m) => { setDauer(m); setVorschlag(null); };
  const verwerfeVorschlag = () => setVorschlag(null);
  return { istAufgabe, dauer, setzeDauer, vorschlag, springe, angezeigt, aendereWahl, sichtbareTermine, ersteSuche, weitere, vorschlagWerte, verwerfeVorschlag };
};
